import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const UsageReportUserPageDtoSchema = z.object({
  path: z.string(),
  label: z.string(),
  durationSeconds: z.number(),
  viewCount: z.number(),
  avgScrollDepthPercent: z.number().nullable(),
  clicksCount: z.number(),
});
export type UsageReportUserPageDto = z.infer<
  typeof UsageReportUserPageDtoSchema
>;

const GetUsageReportByUserResponseDtoSchema = z.object({
  userId: z.number(),
  fullName: z.string(),
  totalDurationSeconds: z.number(),
  sessionsCount: z.number(),
  pages: z.array(UsageReportUserPageDtoSchema),
});

export type GetUsageReportByUserRequestDto = {
  userId: number;
  from: string;
  to: string;
};
export type GetUsageReportByUserResponseDto = z.infer<
  typeof GetUsageReportByUserResponseDtoSchema
>;

export const getUsageReportByUser = (
  { userId, ...params }: GetUsageReportByUserRequestDto,
  config?: AxiosRequestConfig<Omit<GetUsageReportByUserRequestDto, 'userId'>>
) => {
  return api
    .get(`/tracking/usage-report/${userId}`, { params, ...config })
    .then(responseContract(GetUsageReportByUserResponseDtoSchema));
};
